import React, {Component} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {QUESTION_EDIT_MODE, QUESTION_DELETE_MODE, QUESTION_LIST_MODE} from "@irati/insights/constants/question"
import Validation from "@irati/utils/validation"

import {Para} from "../../../ui/Labels"
import {
  Wrapper,
  QuestionWrapper,
  IconButton,
  IconWrapper,
  InputWrapper,
  DeleteWrapper,
  StyledInput,
  ActionButton,
  ValidationActionButton,
  ButtonWrapper
} from "./QuestionEditorStyles"
import QuestionEditorLabel from "./QuestionEdititorLabel"

class QuestionEditor extends Component {
  state = {
    text: "",
    mode: "list"
  }

  static propTypes = {
    question: PropTypes.object,
    onSave: PropTypes.func,
    onDelete: PropTypes.func,
    className: PropTypes.string,
    formatMessage: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    question: {},
    onSave: () => null,
    onDelete: () => null,
    disabled: false
  }

  componentDidMount() {
    const {
      question: {text}
    } = this.props
    this.setState({text, isEditMode: !text})
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.mode === QUESTION_EDIT_MODE) {
      return {text: props.question.text}
    }
    return null
  }

  handleChange = (text) => {
    this.setState({text})
  }

  handleSave = () => {
    const {question} = this.props
    const {text} = this.state
    this.props.onSave(question, text)
    this.setListMode()
  }

  handleCancel = () => {
    const {
      question: {text}
    } = this.props
    this.setState({text})
    this.disableEditMode()
  }

  disableEditMode = () => {
    this.setState({mode: QUESTION_LIST_MODE})
  }

  setEditMode = () => {
    const {disabled} = this.props
    if (!disabled) this.setState({mode: QUESTION_EDIT_MODE})
  }

  setDeleteMode = () => {
    const {disabled} = this.props
    if (!disabled) this.setState({mode: QUESTION_DELETE_MODE})
  }

  setListMode = () => {
    this.setState({mode: QUESTION_LIST_MODE})
  }

  render() {
    const idNamespace = id("QuestionEditor", this.props)
    const {question, onDelete, className, formatMessage, disabled} = this.props
    const {text, mode} = this.state
    const {uuid} = question
    const intlPlaceholder = formatMessage({id: "insights.customSurvey.questionInput.placeholder"})

    return (
      <Wrapper key={uuid}>
        <QuestionWrapper>
          {mode === QUESTION_LIST_MODE && (
            <>
              <Para medium flush>
                {text}
              </Para>
              <IconWrapper>
                <IconButton disabled={disabled} id={id("iconEdit", idNamespace)} onClick={this.setEditMode} icon="editQuestion" size={18} />
                <IconButton disabled={disabled} id={id("iconDelete", idNamespace)} onClick={this.setDeleteMode} icon="delete" size={18} />
              </IconWrapper>
            </>
          )}
          {mode === QUESTION_EDIT_MODE && (
            <InputWrapper>
              <StyledInput
                wide
                type="text"
                placeholder={intlPlaceholder}
                name="addQuestion"
                value={text}
                validation={Validation.string().max(255)}
                className={`${className} clearfix`}
                onChange={this.handleChange}
                label={<QuestionEditorLabel />} />
              <ButtonWrapper>
                <ActionButton marginBottom secondary small onClick={this.handleCancel}>
                  <FormattedMessage id="insights.customSurvey.questionCta.cancel" />
                </ActionButton>
                <ValidationActionButton primary small onClick={this.handleSave}>
                  <FormattedMessage id="insights.customSurvey.questionCta.save" />
                </ValidationActionButton>
              </ButtonWrapper>
            </InputWrapper>
          )}
          {mode === QUESTION_DELETE_MODE && (
            <DeleteWrapper>
              <Para medium flush>
                {text}
              </Para>
              <ButtonWrapper>
                <ActionButton secondary small onClick={this.handleCancel}>
                  <FormattedMessage marginBottom id="insights.customSurvey.questionCta.cancel" />
                </ActionButton>
                <ActionButton primary small onClick={() => onDelete(question)}>
                  <FormattedMessage id="insights.customSurvey.questionCta.delete" />
                </ActionButton>
              </ButtonWrapper>
            </DeleteWrapper>
          )}
        </QuestionWrapper>
      </Wrapper>
    )
  }
}

export default injectIntl(QuestionEditor)
